import { RouteObject } from 'react-router-dom';
import { lazyImport } from 'shared/routing/LazyRoute';

const ContactsPage = lazyImport(
  () => import('./ContactsPages'),
  'ContactsPageOutlet',
);
const ContactsPageDetails = lazyImport(
  () => import('./ContactsPages'),
  'ContactsPageDetails',
);

export const contactsRoutes: RouteObject[] = [
  {
    path: '/contacts',
    element: <ContactsPage />,
    children: [
      {
        path: ':contactGUID?/:action?',
        element: <ContactsPageDetails />,
      },
    ],
  },
];
